<div class="cx-one-ui etl-reporting-set-container mx-6" *ngIf="showReportingSetLandingPage">
    <div class="header-container" id="header-container">
        <div class="page-title" data-qa="cxone-etl-reporting-set-title" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Reporting_Set">Reporting Set</div>
        <div>
            <button class="cxone-btn btn-big btn-secondary btn-bg-is-white mr-3" (click)="onRowAction('failed-imports')" cvLocalizedText
                langSection="ETL_Reporting_Set" langKey="Failed_Imports" *ngIf="showFailedImportsBtn">
                Failed Imports
            </button>
            <button class="cxone-btn btn-big btn-primary" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="New_Reporting_Set" (click)="showHideCreateEditForm(true)" *ngIf="showNewReportingSetBtn">New Reporting Set</button>
        </div>
    </div>
    <cxone-omnibar [itemCountLabel]="reportingSetLabel" [isFilterable]="false"
        [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="onSearchCriteriaChange($event)"
        [searchQuery]="searchInput" id="reporting-set-search">
    </cxone-omnibar>
    <cxone-grid class="content-container" id="reporting-set-grid" [gridOptions]="reportingSetGridOptions" *ngIf="isLocalizationSectionLoaded">
    </cxone-grid>
</div>
<div *ngIf="showFailedImports">
    <cv-failed-import-report [pageTitle]="pageTitle" [apiType]="apiType"
        (backAction)="onRowAction()"></cv-failed-import-report>
</div>
<ng-container *ngIf="showCreateEditForm">
    <cv-cxone-reporting-set-create-edit (sectionChange)="showHideCreateEditForm(false)"
        [editReportingSetData]="reportingSetData"></cv-cxone-reporting-set-create-edit>
</ng-container>
